import React, { useRef } from "react";
import Layout from "../../layout/Layout";
import "animate.css";
import useInView from "../../components/useInView"; // Import the custom hook
import publication_image from "../../assets/publication_image.png";
import deepfuse_publi from "../../assets/deepfuse_publi.png";

function Publications() {
  const refJammer = useRef(null);
  const refFusion = useRef(null);

  const isInViewJammer = useInView(refJammer);
  const isInViewFusion = useInView(refFusion);
  return (
    <Layout>
      <div className="pt-16 md:pt-20 bg-white">
        <div className="flex flex-col space-y-2 sm:space-y-10 mx-auto py-2 ">
          <div className="flex justify-center items-center pl-6 pr-6 pb-16 md:pl-12 md:pr-12 lg:pl-24 lg:pr-24 bg-white animate__animated animate__fadeIn">
            <div className="grid grid-cols-1 max-w-4xl items-stretch mx-auto gap-12">
              <p className="text-4xl md:text-5xl text-center leading-normal xs:leading-normal md:leading-normal">
                Publications
              </p>

              <div className="flex flex-col justify-center items-center gap-4">
                <p className="text-xl md:text-2xl text-center leading-normal xs:leading-normal md:leading-normal">
                  Ideas That Matter: A journey of research that transforms
                  questions into discoveries and insights into impactful
                  solutions, documented through publications that challenge
                  norms and create lasting value.
                </p>
                <p className="text-md md:text-lg text-slate-600 text-center leading-normal xs:leading-normal md:leading-normal">
                  {" "}
                  Research contributions that reflect innovation and real
                  impact.
                </p>
              </div>
            </div>
          </div>
          <div
            className="flex justify-center items-center pt-16 pl-6 pr-6 pb-8 sm:p-16 md:p-24 md:pl-12 md:pr-12 md:pt-20 lg:pl-24 lg:pr-24 bg-gray-50"
            id="publications"
          >
            <div className="grid grid-cols-1 gap-16 md:gap-20 items-stretch max-w-6xl mx-auto">
              <div className="text-3xl">Publications</div>
              <div
                className="grid grid-cols-1 lg:grid-cols-2 items-center gap-12 p-8 md:p-12 bg-white shadow-md rounded-2xl"
                ref={refFusion}
              >
                <div className="flex flex-col space-y-6">
                  <div className="flex items-center space-x-3">
                    <p className="text-3xl font-normal text-black">
                      Multi-Modal Image Registration and Fusion
                    </p>
                  </div>
                  <div className="flex items-center space-x-3">
                    <p>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://github.com/DeepFuse-MMIF/deepfuse"
                        className="hover:underline text-md lg:text-lg text-blue-700"
                      >
                        DeepFuse
                      </a>{" "}
                      - A fully functional implementation of this research.
                    </p>
                  </div>
                  <div className="flex flex-col space-y-1">
                    <div className="flex items-center space-x-2 text-md lg:text-lg font-semibold">
                      Research and Development
                    </div>
                    <p className="text-gray-500 text-xs">
                      December 2024 - May 2025
                    </p>
                  </div>

                  <div
                    className={`bg-white p-6 rounded-xl shadow-md transform transition-transform duration-300 hover:scale-105 ${
                      isInViewFusion ? "animate-fadeInUpShort" : ""
                    }`}
                  >
                    <p className="text-gray-700 text-md">
                      Jaskirat Singh, Prabhav Dev, Devender Kumar Saini, Monika
                      Yadav. The research paper has been submitted to a reputed
                      journal for review.
                    </p>
                  </div>

                  <div
                    className={`bg-white p-6 rounded-xl shadow-md transform transition-transform duration-300 hover:scale-105 ${
                      isInViewFusion ? "animate-fadeInUpMedium" : ""
                    }`}
                  >
                    <p className="text-gray-700 text-md">
                      This research introduces a multi-modal fusion technique
                      for medical images that ensures high precision and
                      efficiency. It aligns scans such as CT, MRI, and PET using
                      control point-based registration. The approach integrates
                      VGG-19 for feature extraction, DWT for multi-resolution
                      analysis, and CNN for partial feature fusion, capturing
                      the most relevant features from each modality.
                    </p>
                  </div>
                  <div
                    className={`bg-white p-6 rounded-xl shadow-md transform transition-transform duration-300 hover:scale-105 ${
                      isInViewFusion ? "animate-fadeInUpMedium" : ""
                    }`}
                  >
                    <p className="text-gray-700 text-md">
                      The system undergoes a rigorous registration and fusion
                      process to generate a single, high-quality fused image.
                      This final output retains the diagnostic strengths and
                      specifications of all input scans, offering a more
                      detailed and comprehensive visual for clinical evaluation.
                    </p>
                  </div>

                  <p className="text-gray-600 text-sm">
                    <mark>
                      Registration, Fusion, VGG19, CNN, DWT, DeepFuse, Medical
                      Images React.js, Python
                    </mark>
                  </p>
                </div>

                <div
                  className={`flex justify-center items-center ${
                    isInViewFusion ? "animate-fadeInFormView" : ""
                  }`}
                >
                  <a
                    href="https://github.com/DeepFuse-MMIF/deepfuse"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={deepfuse_publi}
                      alt="WiFi Jammer"
                      className="w-full h-auto rounded-xl border border-gray-200"
                    />
                  </a>
                </div>
              </div>
              <div
                className="grid grid-cols-1 lg:grid-cols-2 items-center gap-12 p-8 md:p-12 bg-white shadow-md rounded-2xl"
                ref={refJammer}
              >
                <div className="flex flex-col space-y-6">
                  <div className="flex items-center space-x-3">
                    <p className="text-3xl font-normal text-black">
                      WiFi Jammer
                    </p>
                  </div>
                  <div className="flex flex-col space-y-1">
                    <div className="flex items-center space-x-2 text-md lg:text-lg font-semibold">
                      Research and Development, UPES
                    </div>
                    <p className="text-gray-500 text-xs">
                      August 2022 - November 2022
                    </p>
                  </div>

                  <div
                    className={`bg-white p-6 rounded-xl shadow-md transform transition-transform duration-300 hover:scale-105 ${
                      isInViewJammer ? "animate-fadeInUpShort" : ""
                    }`}
                  >
                    <p className="text-gray-700 text-md">
                      Keshav Kaushik, Rahul Negi, Prabhav Dev.{" "}
                      <a
                        href="https://ieeexplore.ieee.org/document/10073447"
                        target="_blank"
                        rel="noreferrer"
                        className="hover:underline text-md lg:text-lg text-blue-700"
                      >
                        An electronic warfare approach for deploying a
                        software-based Wi-Fi Jammer
                      </a>
                      , International Conference on Contemporary Computing and
                      Informatics.
                    </p>
                  </div>

                  <div
                    className={`bg-white p-6 rounded-xl shadow-md transform transition-transform duration-300 hover:scale-105 ${
                      isInViewJammer ? "animate-fadeInUpMedium" : ""
                    }`}
                  >
                    <p className="text-gray-700 text-md">
                      The software-based Wi-Fi jammer leverages advanced
                      denial-of-service (DoS) techniques to disrupt targeted
                      wireless networks seamlessly. By initiating a{" "}
                      <b>Wi-Fi DoS de-authentication attack</b>, this tool
                      effectively "jams" the target network, rendering it
                      inaccessible.
                    </p>
                  </div>

                  <div
                    className={`bg-white p-6 rounded-xl shadow-md transform transition-transform duration-300 hover:scale-105 ${
                      isInViewJammer ? "animate-fadeInUpLong" : ""
                    }`}
                  >
                    <p className="text-gray-700 text-md">
                      This powerful capability has significant applications in{" "}
                      <b>defense and military operations</b>, such as:<br></br>
                      {"=>"} Neutralizing enemy drones by jamming their signals.
                      <br></br> {"=>"} Delivering false GPS data to disorient
                      adversarial devices.
                    </p>
                  </div>

                  <p className="text-gray-600 text-sm">
                    <mark>
                      WiFi Jammer, DoS pursuit mode, Airgeddon Tool, Electronic
                      Warfare approach, Wireless Attacks
                    </mark>
                  </p>
                </div>

                <div
                  className={`flex justify-center items-center ${
                    isInViewJammer ? "animate-fadeInFormView" : ""
                  }`}
                >
                  <a
                    href="https://ieeexplore.ieee.org/document/10073447"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={publication_image}
                      alt="WiFi Jammer"
                      className="w-full h-auto rounded-xl border border-gray-200"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Publications;
